import { Metamodel } from '../base/model';
import { IModel, IAttribute, IValidationContext, IViolation } from '../base/annotation';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { ModelConstants } from '../model-constants';
import { LinkedService } from './linkedservice';
import { Named } from '../base/named';

@Metamodel.model({
    name: ModelConstants.fabricMaterializedLakehouseViewLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.FabricMaterializedLakehouseView_DisplayText),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.FabricMaterializedLakehouseView_DisplayText)
    ],
    validator: FMLVLinkedService.validateFMLVLinkedService
})
export class FMLVLinkedService extends LinkedService {
    public static readonly MODEL: IModel;
    public static readonly ARTIFACT_ID: IAttribute;
    public static readonly ENDPOINT: IAttribute;
    public static readonly WORKSPACE_ID: IAttribute;

    public static async validateFMLVLinkedService(
        linkedService: FMLVLinkedService,
        context: IValidationContext
    ): Promise<IViolation[]> {
        // This is a dummy linked service
        return undefined;
    }

    @Metamodel.attribute({
        display: format(shellStringResources.ObjectIdLabel, shellStringResources.FabricMaterializedLakehouseView_DisplayText),
        association: 'ARTIFACT_ID',
        accepts: ['String'],
        templatable: true
    })
    public artifactId?: string;

    @Metamodel.attribute({
        display: shellStringResources.WorkspaceId,
        association: 'WORKSPACE_ID',
        accepts: ['String'],
        templatable: true
    })
    public workspaceId?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Endpoint,
        association: 'ENDPOINT',
        accepts: ['String'],
        templatable: true
    })
    public endpoint?: string;

    @Metamodel.attribute({
        reference: true
    })
    public parentEntity?: Named;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
